import { createSelector } from 'reselect';
import { getCompanySettings } from './getCompanySettings';

export const getWaitingForWorkEnabled = createSelector(
  [getCompanySettings],
  (companySettings) => {
    return companySettings?.enableWaitingForWork ?? false;
  }
);
